import React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

/**
 * Detail title with optional edit control revealed on hover (and always on touch-friendly devices via focus).
 */
export function PostTitle({ title, onEdit }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 0.75,
        mb: 1.5,
        "&:hover .post-title-edit, &:focus-within .post-title-edit": {
          opacity: 1,
          pointerEvents: "auto",
        },
      }}
    >
      <Typography
        variant="h3"
        component="h1"
        sx={{
          fontWeight: 700,
          letterSpacing: "-0.03em",
          fontSize: { xs: "1.75rem", sm: "2.25rem" },
          flex: 1,
          minWidth: 0,
        }}
      >
        {title}
      </Typography>
      {onEdit ? (
        <IconButton
          className="post-title-edit"
          size="small"
          aria-label="Rediger"
          title="Rediger"
          onClick={onEdit}
          sx={{
            mt: 0.5,
            opacity: { xs: 1, sm: 0 },
            pointerEvents: { xs: "auto", sm: "none" },
            transition: "opacity 0.15s ease",
            color: "text.secondary",
            "&:hover": { color: "primary.main", bgcolor: "action.hover" },
          }}
        >
          <EditOutlinedIcon fontSize="small" />
        </IconButton>
      ) : null}
    </Box>
  );
}

export default PostTitle;
